import actions from './actions';

const {
  GET_FINANCING_PARTNER_BEGIN, GET_FINANCING_PARTNER_SUCCESS, GET_FINANCING_PARTNER_FAILED,
  ADD_FINANCING_PARTNER_BEGIN, ADD_FINANCING_PARTNER_SUCCESS, ADD_FINANCING_PARTNER_FAILED,
  UPDATE_FINANCING_PARTNER_BEGIN, UPDATE_FINANCING_PARTNER_SUCCESS, UPDATE_FINANCING_PARTNER_FAILED,
  DELETE_FINANCING_PARTNER_BEGIN, DELETE_FINANCING_PARTNER_SUCCESS, DELETE_FINANCING_PARTNER_FAILED
} = actions;

const initState = {
  total: 0,
  partners: [],
  loading: false,
  error: null,
};


const FinancingPartnerReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_FINANCING_PARTNER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_FINANCING_PARTNER_SUCCESS:
      return {
        ...state,
        total: data.total,
        partners: data.financingPartners,
        loading: false,
      };
    case GET_FINANCING_PARTNER_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_FINANCING_PARTNER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_FINANCING_PARTNER_SUCCESS:
      return {
        ...state,
        total: state.total + 1,
        partners: data,
        loading: false,
      };
    case ADD_FINANCING_PARTNER_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_FINANCING_PARTNER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_FINANCING_PARTNER_SUCCESS:
      return {
        ...state,
        partners: data,
        loading: false,
      };
    case UPDATE_FINANCING_PARTNER_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_FINANCING_PARTNER_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_FINANCING_PARTNER_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        partners: data,
        loading: false,
      };
    case DELETE_FINANCING_PARTNER_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default FinancingPartnerReducer;